import { ResettingFileUpload } from '@/components/FileUpload/ResettingFileUpload';
import { Box, TextLink } from '@palmetto/palmetto-components';

interface FlagInteractionControlsProps {
  hasNoAction: boolean;
  needsFormField: boolean;
  isSpecialFlagSection: boolean;
  flagIsClosed: boolean;
  isReviewer: boolean;
  documentType: string;
  epcFeedbackDocumentType: string;
  handleImmediateUpload: (event: any) => void;
  handleImmediateUploadEvidence: (event: any) => void;
  showNewMessage: () => void;
  isAccountLoading: boolean;
  isQueueLoading: boolean;
  isDocumentsLoading: boolean;
  isUploadingDocument: boolean;
}

export const FlagInteractionControls = ({
  hasNoAction,
  needsFormField,
  isSpecialFlagSection,
  flagIsClosed,
  isReviewer,
  documentType,
  epcFeedbackDocumentType,
  handleImmediateUpload,
  handleImmediateUploadEvidence,
  showNewMessage,
  isAccountLoading,
  isQueueLoading,
  isDocumentsLoading,
  isUploadingDocument,
}: FlagInteractionControlsProps) => {
  return (
    <Box display="flex" direction="row" alignItems={{ base: 'flex-start', tablet: 'center' }} gap="xs">
      {!hasNoAction && !needsFormField && !isSpecialFlagSection && !flagIsClosed && (
        <Box direction="column" childGap="xs" alignItems="flex-end">
          <ResettingFileUpload
            labelText="Upload"
            id={`upload-${documentType}-files`}
            name={`${documentType}-files`}
            multiple
            onChange={handleImmediateUpload}
            tone="primary"
            hasIcon={false}
            buttonText="Upload New Document"
            onClick={(event: any) => event.stopPropagation()}
            isDisabled={isAccountLoading || isQueueLoading || isDocumentsLoading || isUploadingDocument}
          />
        </Box>
      )}
      {hasNoAction && !flagIsClosed && !isReviewer && (
        <ResettingFileUpload
          labelText="Upload"
          id={`upload-${epcFeedbackDocumentType}-files`}
          name={`${epcFeedbackDocumentType}-files`}
          multiple
          onChange={handleImmediateUploadEvidence}
          tone="primary"
          hasIcon={false}
          buttonText="Upload Document"
          onClick={(event: any) => event.stopPropagation()}
          isDisabled={isAccountLoading || isQueueLoading || isDocumentsLoading || isUploadingDocument}
        />
      )}
      {!isReviewer && !flagIsClosed && (
        <TextLink
          onClick={() => showNewMessage()}
          style={{ cursor: 'pointer', textDecoration: 'underline', color: '#44474B' }}
        >
          I have questions about this issue
        </TextLink>
      )}
    </Box>
  );
};
